import useCallApi from '../../utilities/axios'
import { FileInfo } from './types/responseWebServiceTypes'
import { getOfficeFile as getOfficeFileUrl, updateOfficeFile as updateOfficeFileUrl } from './webServiceURL'

export interface DocumentInfo {
    fileInfo: FileInfo[]
    title: string
    remark: string
}

export interface DocumentInfoReqeust {
    fileTokenInfo: string[]
    title: string
    remark: string
}

export interface OfficeFile {
    documentInfo: DocumentInfo[]
}

export interface OfficeFileRequest {
    projectID: number
    documentInfo: DocumentInfoReqeust[]
}

export default function useOfficeFile() {
    const callApi = useCallApi()

    async function getOfficeFiles(projectId: number) {
        const { data } = await callApi.axiosGet<{
            message: string
            status: number
            result: OfficeFile
        }>({
            url: `${getOfficeFileUrl}/${projectId}`,
        })

        return data
    }

    async function updateOfficeFile(params: OfficeFileRequest) {
        const { data } = await callApi.axiosPut<{
            message: string
            status: number
            result: string
        }>({ url: updateOfficeFileUrl, params })

        return data
    }

    return { getOfficeFiles, updateOfficeFile }
}
